import React, {
    useEffect, useRef, useState,
} from 'react';

const CookieConsent = () => {
    const [visible, setVisible] = useState(false);
    const [previouslyAccepted, setPreviouslyAccepted] = useState(false);
    const title = useRef(null);

    useEffect(() => {
        setVisible(!window.A1Consent?.get());
        const open = () => {
            setPreviouslyAccepted(window.A1Consent?.allowed() === true);
            setVisible(true);
            requestAnimationFrame(() => title.current?.focus());
        };

        window.addEventListener('a1-consent-open', open);

        return () => window.removeEventListener('a1-consent-open', open);
    }, []);

    const choose = (choice) => {
        window.A1Consent?.set(choice);
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <section id="cookieConsent" className="cookieConsent" aria-labelledby="cookie-consent-title">
            <h2 id="cookie-consent-title" ref={title} tabIndex={-1}>Sua escolha de cookies</h2>
            <p>
                Usamos cookies opcionais para medir a audiência e personalizar anúncios.
                Você pode recusar e continuar usando o site e ouvindo a rádio.
                {' '}
                <a href="/termos/privacidade">Política de privacidade</a>
            </p>
            {previouslyAccepted && <p>Ao recusar agora, a página será recarregada e a reprodução será interrompida.</p>}
            <div className="cookieConsentActions">
                <button type="button" onClick={() => choose('rejected')}>Recusar opcionais</button>
                <button type="button" onClick={() => choose('accepted')}>Aceitar opcionais</button>
            </div>
            <p className="cookieConsentNote">Altere sua escolha em “Preferências de cookies”, no rodapé.</p>
        </section>
    );
};

export default CookieConsent;
